import { CATEGORY_LABELS, CATEGORY_ORDER } from "./categories";

// Group lines by category (macarons, seasonal, pans, ...) in standard order, A–Z inside.
export function groupByCategory(lines, getCat = (l) => l.category || "other") {
  const by = {};
  lines.forEach((l, idx) => (by[getCat(l)] ??= []).push({ ...l, _idx: idx }));
  const order = [...CATEGORY_ORDER, ...Object.keys(by).filter((c) => !CATEGORY_ORDER.includes(c))];
  return order.filter((c) => by[c]?.length).map((c) => ({
    cat: c,
    label: CATEGORY_LABELS[c] || c,
    items: by[c].sort((a, b) => (a.name || "").localeCompare(b.name || "")),
  }));
}
